import 'script-loader!bootstrap4-tagsinput/tagsinput';
